<template>
  <!-- 样式宽度配置
       @author: 王汝鹏
       @date: 2019-9-16
   -->
  <div class="setting-item">
    <el-form-item label="组件宽度(cm)"> 
      <el-input-number v-model.number="width" 
                       class="setting-style_height"
                       controls-position="right"
                       placeholder="请输入宽度"
                       :precision=precision
                       :step=step
                       :min="0" 
                       :max="30"></el-input-number>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
// 导入设置项混入文件
import mixSettingData from '@/mixins/common/mix_setting_data.js';
export default {
  mixins: [ mixValueWatch,mixSettingData ],
  computed: {
    /** @name 宽度
     *  @description 将 width 字段映射到当前 width 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-16
     */
    ...mapComputed({
      width: { 
        parent: i => i.styleOption,
        attr: "width",
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/style_setting/SettingStyleWidth.vue